export const ATTENDANCE_TIME_ZONE = "Asia/Jakarta";
export const ATTENDANCE_LOCALE = "id-ID";
export const JAKARTA_OFFSET_MINUTES = 7 * 60;

const getParts = (date, timeZone = ATTENDANCE_TIME_ZONE) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });

  return formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== "literal") acc[part.type] = part.value;
    return acc;
  }, {});
};

export const formatJakartaIsoLocal = (date = new Date()) => {
  const parts = getParts(date, ATTENDANCE_TIME_ZONE);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}+07:00`;
};

export const buildAttendanceTimePayload = (date = new Date()) => ({
  attendance_time_utc: date.toISOString(),
  attendance_time_local: formatJakartaIsoLocal(date),
  attendance_timezone: ATTENDANCE_TIME_ZONE,
  attendance_timezone_offset_minutes: JAKARTA_OFFSET_MINUTES,
  attendance_locale: ATTENDANCE_LOCALE,
});
